import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/doctorAvatar.svg'


const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["cx", "cy", "r", "stroke", "stroke-width"]
const _hoisted_3 = ["cx", "cy", "r", "stroke", "stroke-width", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Avatar do médico",
  class: "w-full h-full rounded-full object-cover"
}, null, -1)

import { computed } from 'vue'
import { classifyNpsScore, NEUTRAL_RING_COLOR } from '@/utils/nps'
import { resolveAvatarSrc } from '@/utils/avatar'
import ProtectedAvatar from './ProtectedAvatar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NpsScoreAvatar',
  props: {
    npsScore: { default: null },
    avatarUrl: { default: null },
    size: { default: 40 },
    strokeWidth: { default: 6 }
  },
  setup(__props: any) {

const props = __props;



const resolvedAvatar = computed(() => resolveAvatarSrc(props.avatarUrl))

const radius = computed(() => props.size / 2 + props.strokeWidth / 2)
const svgSize = computed(() => radius.value * 2 + props.strokeWidth)
const circumference = computed(() => 2 * Math.PI * radius.value)

const clampedScore = computed(() => {
  if (props.npsScore == null) return 0
  return Math.min(100, Math.max(0, (props.npsScore + 100) / 2))
})
const offset = computed(() => circumference.value * (1 - clampedScore.value / 100))
const color = computed(() =>
  props.npsScore == null ? NEUTRAL_RING_COLOR : classifyNpsScore(props.npsScore).color
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative shrink-0",
    style: _normalizeStyle({ width: svgSize.value + 'px', height: svgSize.value + 'px' })
  }, [
    (_openBlock(), _createElementBlock("svg", {
      width: svgSize.value,
      height: svgSize.value,
      class: "absolute top-0 left-0 -rotate-90",
      "aria-hidden": "true"
    }, [
      _createElementVNode("circle", {
        cx: svgSize.value / 2,
        cy: svgSize.value / 2,
        r: radius.value,
        stroke: _unref(NEUTRAL_RING_COLOR),
        "stroke-width": _ctx.strokeWidth,
        fill: "none"
      }, null, 8, _hoisted_2),
      (_ctx.npsScore != null)
        ? (_openBlock(), _createElementBlock("circle", {
            key: 0,
            cx: svgSize.value / 2,
            cy: svgSize.value / 2,
            r: radius.value,
            stroke: color.value,
            "stroke-width": _ctx.strokeWidth,
            fill: "none",
            "stroke-dasharray": circumference.value,
            "stroke-dashoffset": offset.value,
            "stroke-linecap": "round"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1)),
    _createVNode(ProtectedAvatar, {
      src: resolvedAvatar.value,
      size: _ctx.size,
      class: "absolute",
      style: _normalizeStyle({ top: _ctx.strokeWidth + 'px', left: _ctx.strokeWidth + 'px' })
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_4
        ])
      ]),
      _: 3
    }, 8, ["src", "size", "style"])
  ], 4))
}
}

})